import React, { useCallback, useEffect } from 'react';

import { Box } from '@chakra-ui/react';
import dayjs from 'dayjs';
import { useDispatch } from 'react-redux';

import { CDashboard } from 'components/Visualization';
import { useAccessBoundary } from 'containers/App/hooks/useAccessBoundary';
import { actions } from 'containers/Visibility/Data/slice';

import { dashboardWidgets1 } from './Dashboard/config';

export const DataDashboard: React.FC = () => {
  const dispatch = useDispatch();
  const { accountId, environmentId } = useAccessBoundary();

  const getDashboardData = useCallback(() => {
    const payload = {
      environmentId,
      accountIds: !!accountId ? [accountId] : undefined,
    };
    dispatch(
      actions.getAnalyzedSources({
        q: payload,
      }),
    );
    dispatch(
      actions.getSensitiveDataLabelCount({
        q: payload,
      }),
    );
    dispatch(
      actions.getRuntimeInsights({
        q: {
          ...payload,
          endDate: dayjs().utc().format('YYYY-MM-DD'),
          startDate: dayjs().subtract(29, 'days').utc().format('YYYY-MM-DD'),
        },
      }),
    );
    dispatch(
      actions.getSummaryOfAllDataSources({
        q: { ...payload, accountId: !!accountId ? [accountId] : undefined },
      }),
    );
    dispatch(
      actions.getSensitiveDataByAgnosticSources({
        q: payload,
      }),
    );

    dispatch(
      actions.getDocumentTypes({
        q: {
          ...payload,
          page: 1,
          size: 50,
        },
      }),
    );

    dispatch(
      actions.getSourcesByAccounts({
        q: payload,
      }),
    );

    dispatch(
      actions.getDataSourcesPieChartData({
        q: payload,
      }),
    );
    dispatch(
      actions.getSensitiveDataByRegion({
        q: { ...payload, dataType: 'sensitive_data' },
      }),
    );
    dispatch(
      actions.getDataSourcesByRegion({
        q: payload,
      }),
    );
  }, [dispatch, environmentId, accountId]);

  useEffect(() => {
    getDashboardData();
  }, [getDashboardData]);

  return (
    <Box w="full">
      <CDashboard dashboardWidgets={dashboardWidgets1} />
    </Box>
  );
};
